import { render, staticRenderFns } from "./Dotscontrol.vue?vue&type=template&id=0d795fc7&scoped=true&"
import script from "./Dotscontrol.vue?vue&type=script&lang=js&"
export * from "./Dotscontrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d795fc7",
  null
  
)

export default component.exports